/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, September 11th 2022, 2:35:26 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { DnDItemTypes } from "config";
import { TaskTemplate } from "lib/schemas";
import { GenericDropTarget } from "ui-widgets/drag-and-drop";
import { INodeTypeDnDSelectorState } from "./types";

interface NewTaskTemplateDropTargetWrapperProps {
  onDropTaskTemplateType: (newNodeType: TaskTemplate["type"], newNodeTitle: TaskTemplate["title"]) => void;
  children: React.ReactNode;
}

export const NewTaskTemplateDropTargetWrapper = ({
  onDropTaskTemplateType,
  children,
}: NewTaskTemplateDropTargetWrapperProps) => {
  return (
    <GenericDropTarget<INodeTypeDnDSelectorState>
      itemType={DnDItemTypes.OS_ADD_NEW_TASK_TEMPLATE}
      handleDrop={({ newNodeType, newNodeTitle }) => onDropTaskTemplateType(newNodeType, newNodeTitle)}
    >
      <div style={{ minHeight: 600 }}>{children}</div>
    </GenericDropTarget>
  );
};
